var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
        },
      },
      _vm.$listeners
    ),
    [
      _c(
        "g",
        {
          staticClass:
            "status-incomplete_svg__status-incomplete_svg__ic-cw-status-dot-incomplete-paper-24",
          attrs: { fill: "none", "fill-rule": "evenodd" },
        },
        [
          _c("path", {
            staticClass:
              "status-incomplete_svg__status-incomplete_svg__ic-cw-status-dot-incomplete-paper-24__bg",
            attrs: { d: "M0 0h24v24H0z" },
          }),
          _c(
            "g",
            {
              staticClass:
                "status-incomplete_svg__status-incomplete_svg__ic-cw-status-dot-incomplete-paper-24__icon",
              attrs: { fill: "#FAAA5A", "fill-rule": "nonzero" },
            },
            [
              _c("path", {
                staticClass:
                  "status-incomplete_svg__status-incomplete_svg__ic-cw-status-dot-incomplete-paper-24__icon__oval",
                attrs: {
                  d: "M12 6a6 6 0 110 12 6 6 0 010-12zm0 2a4 4 0 100 8 4 4 0 000-8z",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }